import { queryAll, queryOne, touchElementP } from 'lambda-dom'

import '@app-bootstrappers/banner.bootstrapper'
import { ClusteredMap, HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'
import { googleMapsStyleSheet, mainOfficeCoordinates } from '@app-config'
import { createWindowMarker, getCompanyLocations, loadGoogleMapsApi } from '@app-helpers'
import LocationForm from './locations-form'

// ------------------------------------------------------------------------------
//      Navigation theme handling
// ------------------------------------------------------------------------------

{
    const heroContainer = document.getElementById('who-we-are-hero')!

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
}

// ------------------------------------------------------------------------------
//      Initialize company locations map + filter form
// ------------------------------------------------------------------------------

(async function initCompaniesMap(): Promise<void> {
    await loadGoogleMapsApi()

    const companiesMapContainer = await touchElementP<HTMLElement>('#companies-map')

    const companiesMap = new ClusteredMap(companiesMapContainer, {
        center: mainOfficeCoordinates,
        zoom: 2,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        styles: googleMapsStyleSheet,
    })

    const form = await touchElementP('form[name=location]')
    const locationForm = new LocationForm(companiesMap, form)

    const locations = await getCompanyLocations(new FormData(form))

    if (! locations) {
        return
    }

    const markers = locations.map(createWindowMarker)

    if (! markers) {
        return
    }

    companiesMap.setMarkers(markers)
    locationForm.initialize()
}())

// ------------------------------------------------------------------------------
//      Travel Directions
// ------------------------------------------------------------------------------

const directionSelectors = queryAll('.directions-selection')!
const directionTexts = queryAll('.directions__bottom-text')!

const handleDirectionsClick = (id: string) => {
    const selector = queryOne(`#${id}`)!

    directionSelectors.forEach(directionSelector => {
        directionSelector.classList.remove('active')
    })

    selector.classList.add('active')

    const text = queryOne(`#text-${id}`)!

    directionTexts.forEach(directionText => {
        directionText.classList.remove('active')
    })

    text.classList.add('active')
}

directionSelectors.forEach(selector => {
    selector.addEventListener('click', () => handleDirectionsClick(selector.id))
})

handleDirectionsClick('train')
